import { Pie, Line, Bar, Radar, mixins } from 'vue-chartjs'

function mergeOptions (options) {
  return Object.assign({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        gridLines: {
          display: true // Need to be forced...
        }
      }],
      xAxes: [{
        gridLines: {
          display: false // I dont really like vertical grid lines
        },
        categoryPercentage: 1,
        barPercentage: 0.7
      }]
    }
  }, options)
}

export const PieChart = Pie.extend({
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, mergeOptions(this.options))
  }
})

export const LineChart = Line.extend({
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, mergeOptions(this.options))
  }
})

export const BarChart = Bar.extend({
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, mergeOptions(this.options))
  }
})

export const RadarChart = Radar.extend({
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, mergeOptions(this.options))
  }
})



// WEBPACK FOOTER //
// ./src/components/charts/charts.js